<div class="w-full pr-10 gap-6 flex flex-col">
    <div class="flex w-full justify-between"></div>
  
    <div class="flex h-full gap-10 w-full flex-col xl:flex-row">
      <div class="w-full flex flex-col gap-6">
        <div class="w-full bg-white rounded-xl shadow p-6">
          <!-- Header -->
          <div class="flex items-center gap-2 mb-4">
            <div class="h-8 w-1 bg-primary rounded"></div>
            <span class="text-lg font-semibold text-gray-800">Import</span>
          </div>
  
          <!-- Upload Section -->
          <div class="flex flex-col gap-4">
            <div class="flex flex-col sm:flex-row sm:items-center gap-4">
              <!-- Upload Button -->
              <div class="flex items-center">
                <label for="fileInput" class="cursor-pointer bg-primary text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-primary/90 transition">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none">
                    <path d="M9 16H15V10H19L12 3L5 10H9V16ZM5 18H19V20H5V18Z" fill="#F5F5F5"/>
                  </svg>
                  <span>Upload</span>
                </label>
                <input
                  type="file"
                  id="fileInput"
                  (change)="onFileSelected($event)"
                  accept=".xsl,.xslt"
                  hidden
                />
              </div>
  
              <!-- Tooltip -->
              <span class="text-sm text-gray-500">Accepted: .xsl, .xslt (Max: 3MB)</span>
            </div>
  
            <!-- Error Message -->
            <div *ngIf="errorMessage1" class="text-red-600 text-sm">
              {{ errorMessage1 }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  